import {
  Button,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SaveClientReportModal } from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import React, { useState } from 'react';

export type ClientReportsHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportsHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      actionButtons={<ActionButtonsGroup />}
      searchBar={<></>}
      title='Client Reports'
      subtitle=''
    />
  );
};



type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveClientReportModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create Client Report
      </Button>

    </>
  );
};

